/* cwclientelements
   copyright 2019 LOGILAB S.A. (Paris, FRANCE), all rights reserved.
   contact http://www.logilab.fr/ -- mailto:contact@logilab.fr
*/

import * as React from 'react';
import {providers} from '@logilab/cwclientlibjs';
import {
    EntityRelationProps,
    EntityRelationState,
    ENTITY_RELATION_DEFAULT_PROPS,
    EntityRelation,
} from './EntityRelation';
import {ProvidersContext} from './commons';

/**
 * Component for rendering an arbitrary entity relation
 */
export class DefaultEntityRelation extends EntityRelation<
    EntityRelationProps,
    EntityRelationState
> {
    public static contextType = ProvidersContext;
    public context!: React.ContextType<typeof ProvidersContext>;
    public static defaultProps = ENTITY_RELATION_DEFAULT_PROPS;
    state: EntityRelationState;
    _isMounted: boolean;

    constructor(props: Readonly<EntityRelationProps>) {
        super(props);
        let values =
            this.props.entity[
                providers.getUniqueRelationName(this.props.relation)
            ];
        this.state = {
            values: values === null || values === undefined ? [] : values,
            displays: [],
        };
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        Promise.all(
            this.state.values.map((eid: number) => {
                return this.context.schemaProvider
                    .getEntitySchemaById(
                        this.props.entityIsSubject === true
                            ? this.props.relation.to
                            : this.props.relation.from
                    )
                    .then((schema) => {
                        if (schema === null) {
                            return null;
                        }
                        return this.context.entityProvider
                            .getEntityGivenSchema(eid, schema)
                            .then((entity) => {
                                if (entity === null) {
                                    return null;
                                }
                                return this.props.renderDisplayValue(
                                    entity,
                                    schema
                                );
                            });
                    });
            })
        )
            .then((displays: JSX.Element[]) => {
                if (this._isMounted) {
                    this.setState({displays: displays});
                }
            })
            .catch((reason: any) => {
                console.log(reason);
            });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render(): JSX.Element {
        return this.props.render(this);
    }
}
